export default "__VITE_ASSET__BaZjwsDV__"